import Cropper from "cropperjs";

export default class UserSignUp {
  constructor() {
    const profileImg = document.getElementById("profile-img-next-steps");
    const profileInput = document.getElementById("profile-img-hidden");

    if (profileImg && profileInput) {
      const profileUploader = document.getElementById("profile-img-upload");

      const cropper = new Cropper(profileImg, {
        aspectRatio: 1,
        dragMode: "crop",
        cropend() {
          profileInput.value = this.cropper.getCroppedCanvas().toDataURL();
          profileImg.src = this.cropper.getCroppedCanvas().toDataURL();
          profileUploader.src = this.cropper.getCroppedCanvas().toDataURL();
        },
      });

      $("#profile-img-upload").on("change", () => {
        if (profileUploader && profileUploader.files[0]) {
          const fileReader = new FileReader();

          fileReader.onload = (e) => {
            profileImg.src = e.target.result;
            profileInput.value = e.target.result;
            cropper.replace(e.target.result);
          };
          fileReader.readAsDataURL(profileUploader.files[0]);
        }
      });
    }
  }
}
